export default __webpack_public_path__ + "5f76371f1e493c916d2d43bff4d1c842.png";